import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { CookieEnabledGuard } from './shared/cookie-enabled.guard'
import { requireInitialConfigResolver } from './shared/app-config/require-initial-config.resolver'

const routes: Routes = [
  {
    path: '',
    canActivateChild: [CookieEnabledGuard],
    resolve: [requireInitialConfigResolver],
    children: [
      {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full',
      },
      {
        path: 'auth',
        loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'reset-password',
        loadChildren: () => import('./reset-password/reset-password.module').then((m) => m.ResetPasswordModule),
      },
      {
        path: 'sign-up',
        loadChildren: () => import('./sign-up/sign-up.module').then((m) => m.SignUpModule),
      },
      {
        path: 'pending-operation',
        loadChildren: () =>
          import('./pending-operation/pending-operation.module').then((m) => m.PendingOperationModule),
      },
      {
        path: 'sign-up-finalization',
        loadChildren: () =>
          import('./sign-up-finalization/sign-up-finalization.module').then((m) => m.SignUpFinalizationModule),
      },
    ],
  },
  { path: '404', redirectTo: '/feedback/404', pathMatch: 'full' },
  { path: '**', redirectTo: '/feedback/404' },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
